import { NursingPlacementItem } from "./NursingPlacementItem";

export default NursingPlacementItem;
